<template>
    <div :id="getId" class="popup-filter" v-click-outside="hide">
        <div class="card-body" :key="componentKey">
            <b-row v-if="!esconderOrdenacao">
                <b-col class="mb-0">
                    <a class="popup-filter-order" @click="sortingChanged('asc')">
                        Classificar A <i class="fa fa-long-arrow-right"></i> Z
                    </a>
                </b-col>
            </b-row>
            <b-row v-if="!esconderOrdenacao">
                <b-col class="mt-2 mb-0">
                    <a class="popup-filter-order" @click="sortingChanged('desc')">
                        Classificar Z <i class="fa fa-long-arrow-right"></i> A
                    </a>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'texto' && filtro.mascara == null" :key="componentKey">
                <b-col class="mt-3 mb-0">
                    <b-form-group
                        label="Filtrar o texto em:"
                        label-for="valor"
                        :key="componentKey">
                        <b-form-select v-model="filtro.filtrarEm" class="mb-3" :key="componentKey">
                            <template v-slot:first>
                                <option :value="null">Qualquer parte</option>
                            </template>
                            <template>
                                <option :value="1">Início do texto</option>
                            </template>
                            <template>
                                <option :value="2">Final do texto</option>
                            </template>
                            <template>
                                <option :value="3">Está vazio</option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'texto' && filtro.filtrarEm != 3">
                <b-col class="mt-3 mb-0">
                    <b-form-group
                        label="Filtrar pelo texto:"
                        label-for="campoTexto">
                        <b-form-input type="text" name="campoTexto" maxlength="250" v-model="filtro.campoValor"
                                      @keyup="enterField"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row :style="filtro.mascara != null && filtro.filtrarEm != 3 ? 'display: block;' : 'display:none;'">
                <b-col class="mt-3 mb-0">
                    <b-form-group
                        label="Filtrar pelo valor:"
                        label-for="campoMascara">
                        <b-form-input id="campoMascara" type="text" maxlength="250" v-model="filtro.campoMascara" @keyup="enterField"
                                      v-mask="filtro.mascara != null ? filtro.mascara : ''"
                                      v-if="filtro.mascara != 'telefone' && filtro.mascara != 'cpfCnpj'"></b-form-input>
                        <b-form-input id="campoMascara" type="text" maxlength="250" v-model="filtro.campoMascara" @keyup="enterField"
                                      v-mask="['(##) #####-####', '(##) ####-####']"
                                      v-if="filtro.mascara == 'telefone'"></b-form-input>
                        <b-form-input id="campoMascara" type="text" maxlength="250" v-model="filtro.campoMascara" @keyup="enterField"
                                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                                      v-if="filtro.mascara == 'cpfCnpj'"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'data' || filtro.tipo == 'numerico'">
                <b-col class="mt-3 mb-0">
                    <b-form-group
                        :label="'Filtrar ' + (filtro.tipo == 'data' ? 'a data:' : 'o valor:')"
                        label-for="valor">
                        <b-form-select v-model="filtro.filtrarEm" class="mb-3" name="valor">
                            <template v-slot:first>
                                <option :value="null">Igual</option>
                            </template>
                            <template>
                                <option :value="1">Maior que</option>
                            </template>
                            <template>
                                <option :value="3">Maior Igual a</option>
                            </template>
                            <template>
                                <option :value="2">Menor que</option>
                            </template>
                            <template>
                                <option :value="4">Menor Igual a</option>
                            </template>
                            <template>
                                <option :value="5">Está vazio</option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'data' && filtro.filtrarEm != 5">
                <b-col class="mt-3 mb-0">
                    <label>
                        Filtro por Data:
                    </label>
                    <b-input v-model="filtro.campoValor" type="date"></b-input>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'numerico' && filtro.filtrarEm != 5">
                <b-col class="mt-3 mb-0">
                    <label>
                        Filtro por valor:
                    </label>
                    <money class="form-control"
                           v-model="filtro.campoValor"
                           v-bind="money"
                           @keyup="enterField"></money>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'radio'">
                <b-col class="mt-3 mb-0">
                    <p>
                        Filtro por opção:
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                            name="radio-group-9"
                            :options="filtro.listaValores"
                            @change="selectRadio"
                            v-model="filtro.campoValor"
                            class="radio-filter">
                            <template v-slot:first>
                                <b-form-radio :value="null">Ambos</b-form-radio>
                            </template>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="filtro.tipo == 'checkbox'">
                <b-col class="mt-3 mb-0">
                    <p>
                        Filtro por opções:
                    </p>
                    <b-form-checkbox-group
                        id="checkboxSituacao"
                        v-model="filtro.campoValor"
                        value-field="idFilter"
                        text-field="nome"
                        :options="filtro.listaValores"
                        @input="changeData">
                    </b-form-checkbox-group>
                </b-col>
            </b-row>
            <hr class="mt-2 mb-2">
            <b-row class="justify-content-center">
                <div class="d-flex justify-content-between">
                    <b-button variant="outline-info" @click="limpar">
                        <i class="fa fa-eraser" v-b-popover.hover.top="'Limpar'"></i>
                    </b-button>
                    <b-button variant="outline-secondary" style="margin: 0 10px" @click="cancelar">
                        <i class="fa fa-ban" v-b-popover.hover.top="'Cancelar'"></i>
                    </b-button>
                    <b-button variant="outline-primary" @click="ok">
                        <i class="fa fa-check-circle" v-b-popover.hover.top="'Ok'"></i>
                    </b-button>
                </div>
            </b-row>
        </div>
    </div>
</template>
<script>
import ClickOutside from 'vue-click-outside'
import formatarMixins from '../../../mixins/formatarMixins'
import { Money } from 'v-money'

export default {
    props: [ 'filtro', 'compId', 'esconderOrdenacao' ],
    components: {
        Money
    },
    mixins: [ formatarMixins ],
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: false
            },
            componentKey: 0,
            allowClose: false
        }
    },
    computed: {
        getId () {
            return this.compId ? this.compId : 'popup'
        },
    },
    methods: {
        closeFilterPopup() {
            document.getElementById(this.getId).style.display = 'none';
            this.allowClose = false;
        },
        openCloseFilterPopup (event, relative, lefRelative, topRelative) {
            var left = 0
            this.componentKey += 1;

            if (relative) {
                left = event.pageX - lefRelative
            } else {
                left = (event.pageX + 5);
                if((left + 220) > window.screen.width) {
                    left = window.screen.width - 220;
                }
            }

            document.getElementById(this.getId).style.left = left + 'px';
            document.getElementById(this.getId).style.top =  ((relative ? topRelative : event.pageY) + 5) + 'px';
            document.getElementById(this.getId).style.display = 'block';

            this.allowClose = false;

                setTimeout(()=>{
                    this.allowClose = true;
                }, 200);
            },
            hide() {
                if(this.allowClose) {
                    this.closeFilterPopup();
                }
            },
            enterField(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    this.closeFilterPopup();
                    this.tratarValores();
                    this.$emit('filtrarResultados', false);
                }
            },
            changeData(event) {
                this.closeFilterPopup();
                this.tratarValores();
                this.$emit('filtrarResultados', false);
            },
            selectRadio(event) {
                this.filtro.campoValor = event;
                this.closeFilterPopup();
                this.tratarValores();
                this.$emit('filtrarResultados', false);
            },
            ok() {
                this.closeFilterPopup();
                this.tratarValores();
                this.$emit('filtrarResultados', false);
            },
            cancelar() {
                this.closeFilterPopup();
            },
            limpar() {
                this.closeFilterPopup();
                this.$emit('filtrarResultados', true);
            },
            tratarValores() {
                if(this.filtro.tipo == 'checkbox' && !Array.isArray(this.filtro.campoValor) && this.filtro.campoValor != null) {
                    this.filtro.campoValor = [this.filtro.campoValor];
                }
            },
            sortingChanged(order) {
                this.closeFilterPopup();
                this.$emit('ordenarResultados', order);
            },
        },
        directives: {
            ClickOutside
        }
    }
</script>
